module.exports = __webpack_public_path__ + "img/IMG_4117.0d312641.jpeg";